<template>
    <div class="stats">
        <v-btn color="grey" icon flat @click="toogleSection = !toogleSection">
            <v-icon small color="primary">{{ toogleSection ? "fa-angle-up" : "fa-angle-down" }}</v-icon>
        </v-btn>

        <v-fade-transition>
            <div :key="`transitionGroup`" v-if="toogleSection">
                <v-flex sm12 class="pt-0">
                    <v-autocomplete
                        v-model="filterCategories"
                        :items="empleadoChartsCategories"
                        item-value="text"
                        return-object
                        hide-selected
                        placeholder="seleccione..."
                        label="Agrupar por"
                        multiple
                        persistent-hint
                        deletable-chips
                        small-chips
                        dense
                        clearable
                        tags
                        ref="selectedCamposRef"
                        hide-details
                    >
                    </v-autocomplete>
                </v-flex>

                <v-flex sm12 class="my-1" align="center">
                    <v-layout>
                        <v-fade-transition leave-absolute>
                            <strong class="mx-4 my-1 black--text"> Filtros: {{ filterCategories.length }} </strong>
                        </v-fade-transition>
                        <v-fade-transition leave-absolute>
                            <strong class="mx-4 my-1 green--text"> Activos: {{ activeFilters }} </strong>
                        </v-fade-transition>

                        <v-spacer></v-spacer>

                        <v-btn
                            color="success"
                            small
                            class="my-0"
                            :disabled="activeFilters === 0"
                            :loading="loading"
                            @click="applyFilter()"
                        >
                            Aplicar
                        </v-btn>
                    </v-layout>
                </v-flex>

                <v-divider class="mb-4 ml-1"></v-divider>

                <v-card v-if="filterCategories.length">
                    <v-list>
                        <v-slide-y-transition class="py-0" group tag="v-list">
                            <template v-for="(campo, i) in filterCategories">
                                <v-divider v-if="i !== 0" :key="`${i}-divider`" class="pb-0"></v-divider>
                                <v-list-tile :key="i">
                                    <v-list-tile-action>
                                        <v-checkbox
                                            v-model="campo.activo"
                                            color="info"
                                            class="mt-3"
                                            :disabled="getDisabledStatus(campo)"
                                        >
                                        </v-checkbox>
                                    </v-list-tile-action>

                                    <v-list-tile-content>
                                        <template v-if="campo.text === 'Estado'">
                                            <v-select
                                                v-model="empleadoChartsCategories[0].value"
                                                :items="estadoItems"
                                                label="Estado"
                                                item-text="text"
                                                item-value="value"
                                                class="mt-3"
                                            >
                                            </v-select>
                                        </template>

                                        <template v-if="campo.text === 'Puesto'">
                                            <v-select
                                                v-model="empleadoChartsCategories[1].value"
                                                :items="PUESTOS"
                                                label="Puesto"
                                                item-text="nombre"
                                                item-value="id"
                                                class="mt-3"
                                            >
                                            </v-select>
                                        </template>

                                        <template v-if="campo.text === 'Campus'">
                                            <v-select
                                                v-model="empleadoChartsCategories[2].value"
                                                :items="CAMPUS"
                                                label="Campus"
                                                item-text="nombre"
                                                item-value="id"
                                                class="mt-3"
                                            >
                                            </v-select>
                                        </template>

                                        <template v-else-if="campo.text === 'Sección'">
                                            <v-select
                                                v-if="empleadoChartsCategories[2].value !== ''"
                                                v-model="empleadoChartsCategories[3].value"
                                                :items="
                                                    SECCIONES.filter(
                                                        el => el.campus_id === empleadoChartsCategories[2].value
                                                    )
                                                "
                                                label="Sección"
                                                item-text="nombre"
                                                item-value="id"
                                                class="mt-3"
                                            >
                                            </v-select>
                                            <v-card-text class="mt-3" v-else>
                                                Seleccione el campus
                                            </v-card-text>
                                        </template>

                                        <template v-if="campo.text === 'Departamento'">
                                            <v-select
                                                v-model="empleadoChartsCategories[4].value"
                                                :items="DEPARTAMENTOS"
                                                label="Departamento"
                                                item-text="nombre"
                                                item-value="id"
                                                class="mt-3"
                                            >
                                            </v-select>
                                        </template>

                                        <template v-else-if="campo.text === 'Estado civil'">
                                            <v-select
                                                v-model="empleadoChartsCategories[5].value"
                                                :items="ESTADOS_CIVIL"
                                                label="Estado civil"
                                                item-text="nombre"
                                                item-value="id"
                                                class="mt-3"
                                            >
                                            </v-select>
                                        </template>

                                        <template v-else-if="campo.text === 'Sexo'">
                                            <v-select
                                                v-model="empleadoChartsCategories[6].value"
                                                :items="SEXOS"
                                                label="Sexo"
                                                item-text="nombre"
                                                item-value="id"
                                                class="mt-3"
                                            >
                                            </v-select>
                                        </template>

                                        <template v-else-if="campo.text === 'Escolaridad'">
                                            <v-select
                                                v-model="empleadoChartsCategories[7].value"
                                                :items="ESCOLARIDADES"
                                                label="Escolaridad"
                                                item-text="nombre"
                                                item-value="id"
                                                class="mt-3"
                                            >
                                            </v-select>
                                        </template>

                                        <template v-else-if="campo.text === 'Título'">
                                            <v-select
                                                v-model="empleadoChartsCategories[8].value"
                                                :items="TITULOS"
                                                label="Título"
                                                item-text="nombre"
                                                item-value="id"
                                                class="mt-3"
                                            >
                                            </v-select>
                                        </template>
                                    </v-list-tile-content>

                                    <v-spacer></v-spacer>

                                    <v-scroll-x-transition>
                                        <v-icon v-if="campo.activo" color="success">
                                            fa-check
                                        </v-icon>
                                    </v-scroll-x-transition>
                                </v-list-tile>
                            </template>
                        </v-slide-y-transition>
                    </v-list>
                </v-card>
            </div>
        </v-fade-transition>
    </div>
</template>

<script>
import Util from "@/util"
import { mapGetters } from "vuex"
export default {
    name: "EmpleadoStatsFilter",
    props: {
        tabSectionQuery: { type: String, default: null },
        loading: { type: Boolean, default: false }
    },
    data() {
        return {
            filterCategories: [],

            //categorias para agrupar los empleados en los graficos
            empleadoChartsCategories: Util.EmpleadoChartsCategories(),

            estadoItems: [
                { text: "Todos", value: "all" },
                { text: "Activos", value: "1" },
                { text: "Bajas", value: "2" },
                { text: "Pendientes", value: "3" },
                { text: "Rechazados", value: "4" }
            ],

            //mostrar seccion del filtro
            toogleSection: true
        }
    },

    methods: {
        getDisabledStatus(campo) {
            return (
                this.empleadoChartsCategories[this.empleadoChartsCategories.findIndex(el => el.text === campo.text)]
                    .value.length === 0
            )
        },

        applyFilter() {
            let customFilter = ""
            this.filterCategories.forEach(campo => {
                if (campo.activo) {
                    customFilter = customFilter + `${campo.attribute}=${campo.value}&`
                }
            })
            customFilter = customFilter.slice(0, -1)
            return this.$emit("applyFilter", {
                customFilter: customFilter,
                activeFilters: this.activeFilters,
                tabSectionQuery: this.tabSectionQuery
            })
        }
    },

    computed: {
        ...mapGetters({
            Campos: "CAMPUS",
            Secciones: "SECCIONES",
            Departamentos: "DEPARTAMENTOS",
            Puestos: "PUESTOS",
            Estados_Civil: "ESTADOS_CIVIL",
            Sexos: "SEXOS",
            Escolaridades: "ESCOLARIDADES",
            Titulos: "TITULOS"
        }),

        CAMPUS() {
            return [{ nombre: "Todos", id: "all" }].concat(this.Campos)
        },

        SECCIONES() {
            return [{ nombre: "Todos", id: "all" }].concat(this.Secciones)
        },

        DEPARTAMENTOS() {
            return [{ nombre: "Todos", id: "all" }].concat(this.Departamentos)
        },

        PUESTOS() {
            return [{ nombre: "Todos", id: "all" }].concat(this.Puestos)
        },

        ESTADOS_CIVIL() {
            return [{ nombre: "Todos", id: "all" }].concat(this.Estados_Civil)
        },

        SEXOS() {
            return [{ nombre: "Todos", id: "all" }].concat(this.Sexos)
        },

        ESCOLARIDADES() {
            return [{ nombre: "Todos", id: "all" }].concat(this.Escolaridades)
        },

        TITULOS() {
            return [{ nombre: "Todos", id: "all" }].concat(this.Titulos)
        },

        activeFilters() {
            return this.filterCategories.filter(campo => campo.activo).length
        }
    },

    watch: {
        filterCategories() {
            setTimeout(() => {
                this.$refs.selectedCamposRef.isMenuActive = false
            }, 50)
        }
    }
}
</script>
